'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
import navigation from '@utilities/navigation';
import initSliders from '@utilities/slider';
import initFaq from '@utilities/faq';
import initForm from '@utilities/form';
import Cookiebar from '@utilities/cookies';
import '@utilities/in-view';

// Init functions:
navigation();
initSliders();
initFaq();
initForm();
Cookiebar.init({
    cookiePrefix: 'OPEN', // optional - recommended to change
    version: '1' // optional - recommended to update. MUST BE STRING
});



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/open.test/frontend/source/javascript/main.js